import React, { Component } from 'react'
import { filter } from 'lodash'

import { 
  ButtonToolbar, ListGroup, ListGroupItem, Glyphicon, Form,
  Checkbox 
} from 'react-bootstrap'

import CitySelector from '../cities/CitySelector.jsx'
import { ExpenseEditor } from '../components/ExpenseEditor.jsx'
import getEmptyExpense from '../lib/emptyExpense.js'
import Button from '../components/Button.jsx'
import { getText } from '../lib/text.js'

type ExpenseSelectorProps = {
  add: Function, 
  CitiesList: string[], 
  ExpensesList: Object[],
  filterCity: string, 
  toggleFilter: boolean => void, 
  changeFilterCity: string => void, 

  language: string
}

class ExpenseSelector extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = { 
      newExpense: getEmptyExpense(),
      creating: false, 
    }
  }

  props: ExpenseSelectorProps;

  resetExpense()  { 
    this.setState({ newExpense: getEmptyExpense() }) 
  }
  
  updateExpense(changes) { 
    this.setState({ newExpense: { ...this.state.newExpense, ...changes } }) 
  }

  render() {
    const filteredList0 = (this.props.filter 
      ? filter(this.props.ExpensesList, ["city", this.props.filterCity])
      : this.props.ExpensesList
    )

    // @TODO (really) sort expenses in ExpenseSelector

    const filteredList = [
      ...(filteredList0.filter(x => !x.city && x.type == "hotel")),
      ...(filteredList0.filter(x => !x.city && x.type != "hotel")),
      ...(filteredList0.filter(x => x.city && x.type == "hotel")),
      ...(filteredList0.filter(x => x.city && x.type != "hotel")),
    ]
    
    return (
      <div style={{}} >
        <div style={{padding: 5}}>

          { 
            this.state.creating 
              ? (
                <div>
                  <h3 style={{fontSize: 18, fontWeight: 400, margin: 5}}>Nuevo gasto</h3>
                  <ExpenseEditor
                    expense={this.state.newExpense}
                    onChange={changes => this.updateExpense(changes)}
                    pickType 
                    pickCity
                  />

                  <ButtonToolbar style={{marginRight: 10}}>
                    <Button glyph="trash" onClick={() => this.resetExpense()}>
                      {getText("Reset")}
                    </Button>

                    <Button
                      glyph="plus"
                      onClick={() => { 
                        this.props.add(this.state.newExpense);
                        this.resetExpense();
                      }}
                    >
                      {getText("Añadir")}
                    </Button>
                  </ButtonToolbar>
                </div>
              )
              : (
                <div style={{}}>

                  <Checkbox 
                    checked={this.props.filter}
                    onChange={evt => this.props.toggleFilter(evt.target.checked)}
                  >
                    {getText("Sólo gastos en la ciudad...")}
                  </Checkbox>

                  {
                    this.props.filter && (
                      <Form inline style={{ maxWidth: 300, marginBottom: 10 }}>
                        <CitySelector
                          labelWidth={50}
                          cityId={this.props.filterCity}
                          onChange={city => this.props.changeFilterCity(city)}
                        />
                      </Form>
                    )
                  }

                  <div style={{zIndex: 10, overflowY: this.props.selected ? "hidden" : "scroll", maxHeight: 480}}>
                    <ListGroup style={{ border: "1px solid rgb(51, 122, 183)"}}>
                      {
                        filteredList.length > 0 
                          ? (
                            filteredList.map((expense, i) => (
                              <ListGroupItem
                                key={expense._id}
                                style={{ position: "relative" }}
                              >
                                {
                                  (this.props.language == "es"
                                    ? (expense.name || expense.title)
                                    : (expense.title || expense.name)) || `[${getText("Gasto sin nombre")}]`
                                }
                                ({expense.type ? `${expense.type}, ` : ""}{expense.city || getText("Cualquier ciudad")})
                                <Button
                                  bsSize="xsmall"
                                  style={{position: "absolute", right: 15}}
                                  onClick={() => this.props.add(expense)}
                                >
                                  <Glyphicon glyph="plus" />
                                </Button>
                              </ListGroupItem>
                            ))
                          )
                          : (<em style={{padding: 15}}>Sin resultados</em>)
                      }
                    </ListGroup>
                  </div>
                  <ButtonToolbar>
                    <Button
                      glyph="plus-sign"
                      onClick={() => this.setState({creating: true})}
                    >
                      {getText("Crear nuevo gasto")}
                    </Button>
                  </ButtonToolbar>
                </div>
              )
          }
        </div>
      </div>
    ) 
  } 
}

export default ExpenseSelector
